/**
 * Indexer event types for real-time notifications and durable event recording.
 */
export enum IndexerEventType {
  INDEX_STARTED = 'indexer:index-started',
  INDEX_COMPLETED = 'indexer:index-completed',
  INDEX_FAILED = 'indexer:index-failed',
  /** Git/collection source watermark advanced after a successful delta sync (IDX-1). */
  SOURCE_SYNCED = 'indexer:source-synced',
  /** Source sync failed — status moved to 'error' with lastError set. */
  SOURCE_FAILED = 'indexer:source-failed',
  /** A media file was enqueued for transcription (indexer.media → agent-worker). */
  MEDIA_ENQUEUED = 'indexer:media-enqueued',
}

/**
 * Pub/sub channel for indexer events.
 */
export const INDEXER_EVENTS_CHANNEL = 'indexer:events';